.drinks-modal{
  .modal-backdrop {
    display: flex !important;
    .modal-dialog-open {
    }
    .modal-dialog {
      width: 450px;
      margin: auto;
      .modal-content {
        border-radius: 5px !important;
        border-width: 0 !important;
        .modal-header {
          background: #687A88;
          color: #FEFFFE;
          text-align: center;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          padding-top: 5px;
          padding-bottom: 5px;
          .close {
            font-size: 35px !important;
            font-weight: 300;
            color: #FEFFFE;
          }
        }
        .modal-body {
          padding-bottom: 10px;
          padding-top: 10px;
          background: #ECECEC;
          border-right: 2px solid #3B4655;
          border-left: 2px solid #3B4655;
          height: 250px;
          overflow: auto;
          .row {
            .icons {
              .img-container {
                width: 20%;
                float: left;
                display: table;
                @for $i from 1 through 55 {
                  @if ($i !=29) {
                    $url: '../../../../../assets/images/Cups/cup_#{$i}.imageset/cup_#{$i}.png';
                    .img#{$i} {
                      cursor: pointer;
                      content: url('#{$url}');
                    }
                    .checked-true{
                      background: white;
                    }
                    .checked-false{
                      background: transparent;
                    }
                  }
                }
              }
            }
          }

          .img-thumbnail {
            display: table-cell;
            margin: 10% auto;
            height:70px;
            cursor: pointer;
            padding: 10px;
          }
        }
        .modal-footer {
          border-top: 0;
          background: #687A88;
          color: whitesmoke;
          text-align: center;
          cursor: pointer;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
          padding-top: 9px;
          padding-bottom: 9px;
          .btn-close{
            border: 1px solid #95083D;
            border-radius: 5px
          }
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/modal/modal.scss